import * as d3 from "d3";

export function drawLinks(svg, sharedFeatures) {
  let { data, selection } = sharedFeatures;
  // Create links (lines)
  const links = svg
    .selectAll(".link")
    .data(data.links)
    .enter()
    .filter(function (d) {
      if (selection === "all") return true;
      else {
        for (let i = 0; i < d.source.labels.length; i++) {
          for (let j = 0; j < d.target.labels.length; j++) {
            if (
              d.source.labels[i] === selection &&
              d.target.labels[j] === selection
            )
              return true;
          }
        }

        return false;
      }
    })
    .append("line")
    .attr("class", "link")
    .attr("key", (d, i) => "link_" + i)
    .attr("id", (d, i) => "link_" + i)
    .style("opacity", (d) => d.recent);

  return links;
}
